export default "__VITE_ASSET__CTlt_Bq1__"